// // SocketProvider.tsx

// import React, { createContext, useContext, useEffect, useState } from "react";
// import { io, Socket } from "socket.io-client";

// interface SocketContextType {
//   socket: Socket | null;
//   isConnected: boolean;
// }

// const SocketContext = createContext<SocketContextType>({
//   socket: null,
//   isConnected: false,
// });

// export const SocketProvider: React.FC<{ userId: string; children: React.ReactNode }> = ({ userId, children }) => {
//   const [socket, setSocket] = useState<Socket | null>(null);
//   const [isConnected, setIsConnected] = useState(false);

//   useEffect(() => {
//     // Guard against running socket connection without a valid userId
//     if (!userId) {
//       console.warn("⚠️ [Socket] Skipped connection: No userId provided.");
//       return;
//     }

//     const socketInstance = io("http://localhost:3000/notifications", {
//       transports: ["websocket"],
//     });

//     // 1. Connection status listeners
//     socketInstance.on("connect", () => {
//       console.log(`🟢 [Socket Connected] Socket ID: ${socketInstance.id}`);
//       setIsConnected(true);
//       socketInstance.emit("joinUserRoom", userId);
//     });

//     socketInstance.on("connect_error", (error) => {
//       console.error("🔴 [Socket Connection Error]:", error.message);
//     });

//     socketInstance.on("disconnect", (reason) => {
//       console.warn(`🟡 [Socket Disconnected]: ${reason}`);
//       setIsConnected(false);
//     });

//     // 2. Catch ALL incoming events from the backend
//     socketInstance.onAny((eventName, ...args) => {
//       console.log(`📥 [Socket Incoming] Event: "${eventName}"`, args);
//     });

//     // 3. Catch ALL outgoing events sent to the backend
//     socketInstance.onAnyOutgoing((eventName, ...args) => {
//       console.log(`📤 [Socket Outgoing] Event: "${eventName}"`, args);
//     });

//     // eslint-disable-next-line react-hooks/set-state-in-effect
//     setSocket(socketInstance);

//     return () => {
//       socketInstance.offAny();
//       socketInstance.offAnyOutgoing();
//       socketInstance.disconnect();
//     };
//   }, [userId]);

//   return <SocketContext.Provider value={{ socket, isConnected }}>{children}</SocketContext.Provider>;
// };

// // eslint-disable-next-line react-refresh/only-export-components
// export const useSocket = () => useContext(SocketContext);

import React, { createContext, useContext, useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

interface SocketContextType {
  socket: Socket | null;
  isConnected: boolean;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
});

export const SocketProvider: React.FC<{ userId?: string; children: React.ReactNode }> = ({ userId, children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!userId) {
      console.warn("⚠️ [Socket] Skipped connection: No userId provided.");
      return;
    }

    const socketInstance = io("http://localhost:3000/notifications", {
      transports: ["websocket"],
    });

    socketInstance.on("connect", () => {
      console.log(`🟢 [Socket Connected] ID: ${socketInstance.id}`);
      setIsConnected(true);
      socketInstance.emit("joinUserRoom", userId);
    });

    socketInstance.on("disconnect", () => {
      setIsConnected(false);
    });

    // Handle "notification" event directly and broadcast globally
    socketInstance.on("notification", (data) => {
      console.log("📥 [SocketProvider] Received Notification:", data);
      window.dispatchEvent(new CustomEvent("app-notification", { detail: data }));
    });

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSocket(socketInstance);

    return () => {
      socketInstance.off("notification");
      socketInstance.disconnect();
      setSocket(null);
    };
  }, [userId]);

  return <SocketContext.Provider value={{ socket, isConnected }}>{children}</SocketContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSocket = () => useContext(SocketContext);
